// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vy_a bhn_b"};